import DefaultService from '@/services/modules/defaults.service';

const banks = async ({ commit }) => {
    const response = DefaultService.getBanks();

    response.then(function (_response) {
        commit('setListBanks', _response);
    });

    return response;
};

const branches = async ({ commit }) => {
    const response = DefaultService.getBranches();

    response.then(function (_response) {
        commit('setListBranches', _response);
    });

    return response;
};

const notifications = async ({ commit }) => {
    const response = DefaultService.getNotifications();

    response.then(function(_response) {
        commit('setListNotifications', _response);
    });

    return response;
};

const proposalStatus = async ({ commit }) => {
    const response = DefaultService.getProposalStatus();

    response.then(function (_response) {
        commit('setListProposalStatus', _response);
    });

    return response;
};

const readNotification = async ({ commit }, _id) => {
    const response = DefaultService.readNotification(_id);

    return response;
}

const states = async ({ commit }) => {
    const response = DefaultService.getStates();

    response.then(function (_response) {
        commit('setListStates', _response);
    });

    return response;
};

export default {
    banks,
    branches,
    notifications,
    proposalStatus,
    readNotification,
    states
};